import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Vitajte späť.");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Prihlásenie zlyhalo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6 grain">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-12 group" data-testid="login-back-home">
          <div className="w-9 h-9 border border-gold/50 flex items-center justify-center text-gold font-serif">
            T
          </div>
          <div className="leading-tight">
            <div className="font-serif text-lg text-cream">Tatra 603</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-gold/80">
              Administrácia
            </div>
          </div>
        </Link>

        <div className="bg-[#111111] border border-white/10 p-10">
          <div className="flex items-center gap-3 mb-2 text-gold">
            <Lock size={16} strokeWidth={1.4} />
            <span className="text-[10px] uppercase tracking-[0.3em]">Vyhradený prístup</span>
          </div>
          <h1 className="font-serif text-3xl text-cream font-light tracking-tight">
            Prihlásenie
          </h1>
          <p className="text-cream/50 text-sm mt-2">
            Vstup pre správcu — prehľad dopytov.
          </p>

          <form onSubmit={handleSubmit} className="mt-10 space-y-6" data-testid="admin-login-form">
            <div>
              <label className="lux-label">E-mail</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                placeholder="admin@tatra603.sk"
                className="lux-input"
              />
            </div>
            <div>
              <label className="lux-label">Heslo</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                placeholder="••••••••"
                className="lux-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="btn-gold w-full justify-center disabled:opacity-60"
            >
              {loading ? "Prihlasujem…" : "Prihlásiť sa"}
            </button>
          </form>
        </div>

        <Link
          to="/"
          className="block text-center mt-8 text-xs uppercase tracking-[0.3em] text-cream/50 hover:text-gold transition"
        >
          ← Späť na stránku
        </Link>
      </div>
    </div>
  );
}
